/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { HydrusColumnFragment } from "@cosmos/hygraph-schema";

import { css, cx } from "@panda/css";
import { Flex } from "@panda/jsx";

import { HydrusColumn } from "./HydrusColumn.molecule";
import { CosmosCard } from "@components/elements";

const cardStyle = css({
	border: "1px solid token(colors.eds.border.subdued)",
	backgroundColor: "token(colors.eds.palette.transparent.light.005)!important", // override CosmosCard
	backdropFilter: "var(--effect-material-blur, blur(50px))",
});

const columnsStyle = css({
	flexDir: "row",
	"& .hydrus-column": { flex: "1", borderInlineEnd: "1px solid token(colors.eds.border.subdued)" },
	"& .hydrus-column:last-child": { borderInlineEnd: "0" },
	lgDown: {
		flexDir: "column",
		"& .hydrus-column": { borderInlineEnd: "0", borderBlockEnd: "1px solid token(colors.eds.border.subdued)" },
		"& .hydrus-column:last-child": { borderBlockEnd: "0" },
	},
});

export type HydrusColumnListProps = {
	columns: HydrusColumnFragment[];
};

export function HydrusColumnList({ columns }: HydrusColumnListProps): React.JSX.Element {
	return (
		<CosmosCard className={cx("hydrus-column-card", cardStyle)} variant="solid" padding={0}>
			<Flex className={cx("hydrus-column-list", columnsStyle)}>
				{columns.map((column, i) => (
					<HydrusColumn key={`hydrus-column-${i}`} animate={false} {...column} />
				))}
			</Flex>
		</CosmosCard>
	);
}
